import { Button, Skeleton } from '@teach/ui'
import { useCreditsDisplay } from '@/components/layout/sidebar/useCreditsDisplay'
import { useTopUp } from '@/features/ai/credits/CreditsDialogContext'
import { formatCredits, formatCreditsWithWord } from '@/features/ai/lib/money'
import coins from '@/assets/loader/flower.svg'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Полоса баланса на всю ширину: монеты, остаток, «Пополнить». */
export const BalanceBanner = () => {
  const { open: openTopUp } = useTopUp()
  const { balance, held, unavailable, shownBalance } = useCreditsDisplay()
  const m = useMessages(messages)

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-2xl bg-foreground/5 p-5">
      <div className="flex min-w-0 items-center gap-4">
        <img src={coins} alt="" aria-hidden="true" draggable={false} className="size-14 shrink-0" />
        <div className="min-w-0">
          <div className="text-sm text-muted-foreground">{m.balance}</div>
          {unavailable ? (
            <p className="text-2xl font-semibold">—</p>
          ) : balance ? (
            <p className="text-2xl font-semibold">{formatCreditsWithWord(shownBalance)}</p>
          ) : (
            <Skeleton className="mt-1 h-8 w-40" />
          )}
          {held ? (
            <p className="text-sm text-muted-foreground">{m.held(formatCredits(held))}</p>
          ) : null}
        </div>
      </div>
      <Button onClick={() => openTopUp(null, 'packages')}>{m.topUp}</Button>
    </div>
  )
}
